import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppWrapper from '../../../components/AppWrapper';
import { breachcrumbPath } from '../../../utils/breadcrumbConst';
import PageTitle from '../../../components/PageTitle';
import { InputWrapper } from '../../../styles/changePasswordStyles';
import { BannerImageSelect } from './Shared/BannerImageSelect';
import InputText from '../../../components/InputText';
import { useBulkEmail } from '../../../hooks/useBulkEmail';
import EditFooterBar from '../../../components/EditFooterBar';

function EmailSetting() {
  const { emailSettings, getEmailSettings, updateEmailSettings } = useBulkEmail();
  const navigate = useNavigate();
  const [image, setImage] = useState<File>({} as File);
  const [imageName, setImageName] = useState<string>('');
  const [facebookUrl, setFacebookUrl] = useState<string>('');
  const [linkedinUrl, setLinkedinUrl] = useState<string>('');
  const [instagramUrl, setInstagramUrl] = useState<string>('');
  const [youtubeUrl, setYoutubeUrl] = useState<string>('');
  const [settingId, setSettingId] = useState<string | number>('');

  const handleSubmit = async () => {
    await updateEmailSettings(
      {
        logo_image_name: imageName,
        facebook_url: facebookUrl,
        linkedin_url: linkedinUrl,
        instagram_url: instagramUrl,
        youtube_url: youtubeUrl,
        id: settingId,
        image,
      },
      settingId
    );
    navigate('/admin/bulkEmail');
  };

  React.useEffect(() => {
    setImageName(image?.name);
  }, [image]);

  React.useEffect(() => {
    const { logo_image_name, facebook_url, linkedin_url, instagram_url, youtube_url, id } =
      emailSettings;
    setImageName(logo_image_name);
    setFacebookUrl(facebook_url);
    setLinkedinUrl(linkedin_url);
    setInstagramUrl(instagram_url);
    setYoutubeUrl(youtube_url);
    setSettingId(id);
  }, [emailSettings]);

  React.useEffect(() => {
    getEmailSettings();
  }, []);

  return (
    <AppWrapper
      breadcrumbs={[
        breachcrumbPath.admin,
        breachcrumbPath.bulkEmail,
        { url: '', name: 'Email Settings' },
      ]}
    >
      <PageTitle title="Email Settings" linkUrl="" buttonText="" showButton={false} />

      <InputWrapper>
        <BannerImageSelect
          style={{ borderBottom: '0px', marginLeft: '0px' }}
          altLabel="Logo Image"
          handleChange={(value: File) => setImage(value)}
          fileName={imageName}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id="facebookKey"
          keyName="facebookKey"
          label="Facebook Url"
          placeholder="https://www.facebook.com/yourpage"
          inputValue={facebookUrl}
          handleHandle={setFacebookUrl}
          theme="form"
          style={{ width: '610px', marginBottom: '4px' }}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id="linkedinKey"
          keyName="linkedinKey"
          label="LinkedIn Url"
          placeholder="https://www.linkedin.com/yourpage"
          inputValue={linkedinUrl}
          handleHandle={setLinkedinUrl}
          theme="form"
          style={{ width: '610px', marginBottom: '4px' }}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id="instagramKey"
          keyName="instagramKey"
          label="Instagram Url"
          placeholder="https://www.instagram.com/yourpage"
          inputValue={instagramUrl}
          handleHandle={setInstagramUrl}
          theme="form"
          style={{ width: '610px', marginBottom: '4px' }}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          id="youtubeKey"
          keyName="youtubeKey"
          label="Youtube Url"
          placeholder="https://www.youtube.com/yourpage"
          inputValue={youtubeUrl}
          handleHandle={setYoutubeUrl}
          theme="form"
          style={{ width: '610px', marginBottom: '4px' }}
        />
      </InputWrapper>
      <EditFooterBar
        handleSubmit={handleSubmit}
        showDelete={false}
        showSave
        showEdit={false}
        showNew={false}
      />
    </AppWrapper>
  );
}

export default EmailSetting;
